import {TypeCPVClass} from './TypeCPVClass';
export class TypeObjCPV {

	public objetPrincipal: TypeCPVClass;

	constructor() {
		this.objetPrincipal = new TypeCPVClass();
	}
}
